import { FlexBox, Text } from '@dixa/lib-shared-habla';
import type { SearchUser } from 'lib-search-types';
import { User } from 'lib-shared-types-api';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';

import { HookFormUserSelect } from 'components/hookForm';
import { getUserDisplayName } from 'utils/user';

export type SelectContactProps = {
  /** The target contact that are being merged into */
  targetContact: User;
  /** When a contact is selected */
  onContactChange: (contact: SearchUser) => void;
};

/** Select contact is a contact selection component */
export const SelectContact = ({
  targetContact,
  onContactChange,
}: SelectContactProps): JSX.Element => {
  const targetContactDisplayName = getUserDisplayName(targetContact);

  const { control } = useForm<{ contact: SearchUser[] }>({
    defaultValues: {
      contact: [],
    },
  });

  const contactValue = useWatch({ control, name: 'contact' });

  useEffect(() => {
    if (contactValue?.[0]) {
      onContactChange(contactValue[0]);
    }
  }, [contactValue, onContactChange]);

  return (
    <FlexBox flexDirection="column" gap="300">
      <Text.Paragraph>
        Select which contact you want to merge with{' '}
        <strong>{targetContactDisplayName}</strong>.
      </Text.Paragraph>

      <HookFormUserSelect
        control={control}
        name="contact"
        label="Select a contact"
        initialArg={{
          filters: {
            strategy: 'all',
            filters: [
              {
                field: 'user_type',
                operator: 'is_one',
                values: [{ value: 'contact' }],
              },
            ],
          },
          sortBy: { field: 'display_name', order: 'asc' },
          pageSize: 20,
        }}
        componentProps={{
          placeholder: 'Search after name, phone number or email',
        }}
      />
    </FlexBox>
  );
};
